// ─────────────────────────────────────────────────────────────────────────
// withAuthGuard — wraps a page component so it guards ITSELF.
//
// This is what makes the not-logged-in handling work with ZERO setup in a host
// project. The package's public page exports (AdminPage, JobsListPage, …) are
// passed through this HOC in src/index.js, so a consumer can simply do:
//
//     import { AdminPage } from '@realtek/core-theme';
//     <Route path="/admin" element={<AdminPage />} />
//
// …and opening /admin without a session shows the "you haven't logged in"
// screen automatically — the consumer never has to wrap anything.
//
// Pass guard overrides per page if needed: withAuthGuard(Page, { loginPath })
// ─────────────────────────────────────────────────────────────────────────
import AuthGuard from './AuthGuard';

export default function withAuthGuard(PageComponent, guardProps) {
  function Guarded(props) {
    return (
      <AuthGuard {...guardProps}>
        <PageComponent {...props} />
      </AuthGuard>
    );
  }
  Guarded.displayName = `withAuthGuard(${
    PageComponent.displayName || PageComponent.name || 'Component'
  })`;
  return Guarded;
}
